module.exports = __webpack_public_path__ + "img/borameymongkul.b3df06de.jpeg";